<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">{{ pageTitle }}</h4>
            <b-button size="sm" variant="outline-dark" class="ml-2 mr-auto" @click="openPhone">📱 手机入仓<small>(핸드폰으로 등록)</small></b-button>
            <small class="text-muted">扫描快递单号 → 登记入仓位置号 → 打印订单号标签(운송장 스캔 → 입창 위치 등록 → 주문번호 라벨 인쇄)</small>
          </div>
          <div class="card-body">
            <!-- 手机入仓 QR 상시 표시(2026-10-04 YZY) — 주소만 담은 QR 이라(토큰 없음) 만료·갱신이 없다. 접은 상태는 이 브라우저에 기억 -->
            <div class="inreg__qr">
              <div class="small font-weight-bold">
                📱 手机入仓<small>(핸드폰)</small>
                <a href="#" class="ml-1" @click.prevent="toggleQr">{{ qrOpen ? '收起(접기)' : '展开(펼치기)' }}</a>
              </div>
              <template v-if="qrOpen">
                <img v-if="phoneQr" :src="phoneQr" alt="" class="inreg__qrimg" @click="openPhone">
                <div class="small text-muted">扫码 → 员工账号登录<br><small>(스캔 → 직원 계정 로그인)</small></div>
              </template>
            </div>
            <!-- ① 운송장 스캔 — USB/블루투스 스캐너는 입력칸에 찍고 Enter -->
            <div class="d-flex flex-wrap align-items-center mb-2 inreg__step" style="gap:8px">
              <span class="inreg__num">1</span>
              <b-form-select v-model="searchType" :options="searchTypeOptions" size="sm" style="width:190px"></b-form-select>
              <input ref="scan" v-model.trim="keyword" type="text" class="form-control form-control-sm inreg__scan" autocomplete="off"
                     :placeholder="searchPlaceholder" :disabled="finding" @keyup.enter="find">
              <b-button size="sm" variant="primary" :disabled="finding || !keyword" @click="find">搜索<small>(검색)</small></b-button>
              <b-spinner v-if="finding" small variant="primary"></b-spinner>
            </div>

            <!-- 못 찾음 — 수동 검색으로 -->
            <div v-if="searched && !rows.length" class="alert alert-warning py-2 mb-2">
              <b>未找到(찾지 못함)</b> — {{ lastKeyword }}
              <span class="ml-2">请切换为 1688订单号 / 货主订单号 手动搜索(위 선택상자를 1688주문번호·화주주문번호로 바꿔 수동 검색하세요)</span>
              <div v-if="others.length" class="small mt-1">
                已不在订单列表(订单列表에 없는 건):
                <span v-for="o in others" :key="o._id" class="badge badge-light border mr-1">{{ o.companyid }} · {{ statusText(o.processStatus) }}</span>
              </div>
            </div>

            <template v-if="rows.length">
              <div class="small text-muted mb-1">
                {{ lastKeyword }} — {{ rows.length }}件<span v-if="others.length">(另有 {{ others.length }}件 已入库/取消, 이미 입고·취소 {{ others.length }}건 제외)</span>
              </div>
              <div class="table-responsive inreg__table">
                <div v-if="rows.some(x => x._multi)" class="alert alert-warning py-1 small mb-1">多包裹订单(운송장이 여러 개): 这个包裹里的商品请手动勾选 — 一个单号不一定包含全部商品(이 소포에 든 상품만 직접 체크하세요)</div>
          <table class="table table-sm table-bordered mb-2">
                  <thead class="thead-light">
                    <tr>
                      <th style="width:28px"><input type="checkbox" :checked="allChecked" @change="toggleAll($event.target.checked)"></th>
                      <th>货主<br><small>(업체)</small></th>
                      <th>订单号<br><small>(주문번호)</small></th>
                      <th>商品<br><small>(상품)</small></th>
                      <th>数量<br><small>(수량)</small></th>
                      <th>组长<br><small>(조장)</small></th>
                      <th>清关方式<br><small>(통관)</small></th>
                      <th>出库形式<br><small>(출고형식)</small></th>
                      <th>状态<br><small>(상태)</small></th>
                      <th>已登记<br><small>(기존 입창위치)</small></th>
                      <th>拍照<br><small>(촬영)</small></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in rows" :key="r._id" :class="{ 'inreg__rocket': r._로켓 }">
                      <td><input v-model="r._checked" type="checkbox"></td>
                      <td class="text-nowrap">{{ r.companyid }}</td>
                      <td class="text-nowrap">
                        <div>{{ r._1688 || '-' }}</div>
                        <small v-if="r.화주주문번호" class="text-muted">货主 {{ r.화주주문번호 }}</small>
                      </td>
                      <td class="inreg__name">
                        <div class="d-flex align-items-center" style="gap:6px">
                          <img v-if="r.옵션이미지 || r.등록이미지" :src="r.옵션이미지 || r.등록이미지" style="cursor:zoom-in" title="点击放大" @click.stop.prevent="openLb([r.옵션이미지 || r.등록이미지], 0)" class="inreg__pimg" alt="">
                          <div>
                            <small class="text-danger">{{ r._옵션 || r.상품명 }}</small>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">{{ r.구매요청수량 }}</td>
                      <td class="text-nowrap"><b-badge v-if="leaderOf(r.companyid)" :style="tagStyle(leaderOf(r.companyid))" class="px-2 py-1">{{ leaderOf(r.companyid) }}</b-badge><span v-else class="small text-danger">等待分配组长</span></td>
                      <td class="text-nowrap">{{ r._통관 || '-' }}</td>
                      <td class="text-nowrap"><span v-if="r._출고" class="badge" :style="r._출고스타일">{{ r._출고 }}</span></td>
                      <td class="text-nowrap">{{ statusText(r.processStatus) }}</td>
                      <td class="text-nowrap">
                        <template v-if="r.입창등록">
                          <b>{{ r.입창등록.위치번호 }}</b>
                          <small class="d-block text-muted">{{ fmt(r.입창등록.등록일시) }}</small>
                        </template>
                      </td>
                      <td><import-photo-panel :item="r" compact></import-photo-panel></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- ② 입창 위치번호 — 库位号 라벨을 스캔하거나 입력 -->
              <div class="d-flex flex-wrap align-items-center mb-2 inreg__step" style="gap:8px">
                <span class="inreg__num">2</span>
                <label class="mb-0">入仓位置号<small>(입창 위치번호)</small></label>
                <input ref="loc" v-model.trim="location" type="text" class="form-control form-control-sm inreg__loc" list="inregLocationList"
                       autocomplete="off" placeholder="扫描/输入 例 A-01-01" :disabled="saving" @keyup.enter="saveAndPrint">
                <datalist id="inregLocationList">
                  <option v-for="c in savedLocations" :key="c" :value="c"></option>
                </datalist>
                <label class="mb-0 ml-2">托盘号<small>(팔레트번호, 직접 입력)</small></label>
                <input v-model.trim="pallet" type="text" maxlength="40" class="form-control form-control-sm" style="width:130px" placeholder="手动输入" :disabled="saving" @keyup.enter="saveAndPrint">
                <label class="mb-0 ml-2">标签张数<small>(라벨 장수)</small></label>
                <input v-model.number="labelQty" type="number" min="1" :max="LABEL_QTY_MAX" class="form-control form-control-sm" style="width:70px">
                <b-button size="sm" variant="success" :disabled="saving || !checkedRows.length || !location" @click="saveAndPrint">
                  💾🖨️ 保存并打印<small>(저장+인쇄)</small>
                </b-button>
                <b-button size="sm" variant="outline-secondary" :disabled="!checkedRows.length || !location" @click="printOnly">🖨️ 仅打印<small>(인쇄만)</small></b-button>
                <span v-if="location && !locationValid" class="small text-danger">位置号格式错误(형식 오류)</span>
                <span v-else-if="location && savedLocations.length && !savedLocations.includes(location.toUpperCase())" class="small text-warning">不在库位号列表(등록된 위치번호 목록에 없음 — 그대로 저장 가능)</span>
              </div>

              <!-- 라벨 미리보기 — 선택한 첫 행 -->
              <div v-if="checkedRows.length" class="mb-3">
                <div class="small text-muted mb-1">标签预览(라벨 미리보기) 80×60mm</div>
                <div class="inreg__preview">
                  <inbound-label :row="checkedRows[0]" :location="location.toUpperCase()" :waybill="lastWaybill"></inbound-label>
                </div>
              </div>
            </template>

            <hr>
            <!-- 系统未找到的快递(2026-10-04 YZY) — 핸드폰에서 찍었는데 구매 건에 없던 운송장. 주문을 찾아 매칭하면 정상 등록 기록으로 바뀐다 -->
            <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px">
              <h6 class="mb-0">⚠ 系统未找到的快递<small>(시스템에 없는 운송장 — 주문 매칭 필요)</small></h6>
              <span class="badge" :class="unmatchedLogs.length ? 'badge-warning' : 'badge-light border'">{{ unmatchedLogs.length }}</span>
              <b-button size="sm" variant="outline-primary" :disabled="unmatchedLoading" @click="loadUnmatched">刷新<small>(새로고침)</small></b-button>
            </div>
            <div v-if="unmatchedLogs.length" class="table-responsive inreg__table mb-3">
              <table class="table table-sm table-bordered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>时间<br><small>(시각)</small></th>
                    <th>快递单号<br><small>(운송장)</small></th>
                    <th>照片<br><small>(사진)</small></th>
                    <th>入仓位置号<br><small>(위치)</small></th>
                    <th>登记人<br><small>(등록자)</small></th>
                    <th>匹配订单<br><small>(주문 매칭)</small></th>
                    <th>删除<br><small>(삭제)</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="l in unmatchedLogs" :key="l._id">
                    <td class="text-nowrap">{{ fmt(l.등록일시) }}</td>
                    <td class="text-nowrap"><b>{{ l.운송장번호 }}</b></td>
                    <td>
                      <a v-for="(ph, i) in (l.사진 || [])" :key="ph.url + i" href="javascript:void(0)" title="点击放大" @click.prevent="openLb((l.사진 || []).map(x => x.url), i)">
                        <img :src="ph.url" class="inreg__pimg mr-1 mb-1" alt="">
                      </a>
                      <small v-if="!(l.사진 || []).length" class="text-muted">—</small>
                    </td>
                    <td class="text-nowrap"><b v-if="l.위치번호">{{ l.위치번호 }}</b><small v-else class="text-danger">未登记位置(위치 없음)</small></td>
                    <td class="text-nowrap">{{ l.등록자 }}</td>
                    <td><b-button size="sm" variant="warning" @click="openMatch(l)">🔗 匹配<small>(매칭)</small></b-button></td>
                    <td><b-button size="sm" variant="outline-danger" :disabled="deleting === l._id" @click="removeLog(l)">🗑️ 删除</b-button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="small text-muted mb-3">没有未找到的快递(없음)</div>

            <!-- 그날 등록 기록 · 재인쇄 -->
            <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px">
              <h6 class="mb-0">登记记录<small>(등록 기록)</small></h6>
              <input v-model="listDate" type="date" class="form-control form-control-sm" style="width:150px" @change="loadList">
              <span class="small">~</span>
              <input v-model="listDateTo" type="date" class="form-control form-control-sm" style="width:150px" :min="listDate" title="结束日期(不填=当天) / 끝 날짜(비우면 하루)" @change="loadList">
              <b-button size="sm" variant="outline-primary" :disabled="listLoading" @click="loadList">刷新<small>(새로고침)</small></b-button>
              <span class="small text-muted">{{ shownLogs.length }}次 · {{ logRowCount }}件 · 每30秒自动刷新<small>(30초마다 자동 새로고침)</small></span>
            </div>
            <!-- 组长 필터 · 체크한 기록을 표로 PDF 인쇄(2026-10-18 崔凡 #86) -->
            <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px">
              <label class="mb-0 small">组长<small>(조장)</small></label>
              <select v-model="leaderFilter" class="form-control form-control-sm" style="width:160px">
                <option value="">全部(전체)</option>
                <option value="__wait">等待分配组长</option>
                <option v-for="n in leaderNames" :key="'lf' + n" :value="n">{{ n }}</option>
              </select>
              <b-button size="sm" variant="outline-secondary" :disabled="!shownLogs.length" @click="pickedLogs = allLogsPicked ? [] : shownLogs.map(l => l._id)">{{ allLogsPicked ? '取消全选' : '全选' }}<small>(보이는 것)</small></b-button>
              <label class="mb-0 small ml-2">托盘号<small>(팔레트)</small></label>
              <input v-model.trim="palletFilter" type="text" class="form-control form-control-sm" style="width:120px" placeholder="托盘号">
              <label class="mb-0 small ml-2">出库<small>(출고)</small></label>
              <select v-model="outFilter" class="form-control form-control-sm" style="width:130px">
                <option value="">全部(전체)</option>
                <option value="no">未出库(미출고)</option>
                <option value="yes">已出库(출고됨)</option>
              </select>
              <b-button size="sm" variant="danger" :disabled="!pickedLogs.length || outBusy" @click="markOut(true)">一键出库<small>(고른 {{ pickedLogs.length }}건)</small></b-button>
              <b-button size="sm" variant="outline-secondary" :disabled="!pickedLogs.length || outBusy" @click="markOut(false)">取消出库<small>(표시 해제)</small></b-button>
              <span class="small ml-2"><b>入仓 {{ outStat.total }}件</b> · <span class="text-success">已出库 {{ outStat.out }}</span> · <span class="text-danger">未出库 {{ outStat.rest }}</span></span>
              <b-button size="sm" variant="outline-secondary" :disabled="!pickedLogs.length" @click="reprintPicked">🖨️ 批量补打<small>(고른 {{ pickedLogs.length }}건 라벨)</small></b-button>
              <b-button size="sm" variant="primary" :disabled="!pickedLogs.length" @click="printPicked">🖨️ 打印PDF表格<small>(고른 {{ pickedLogs.length }}건)</small></b-button>
              <b-button size="sm" variant="success" :disabled="!shownLogs.length" @click="downloadExcel">📥 下载Excel表格<small>({{ pickedLogs.length ? '고른 ' + pickedLogs.length + '건' : '보이는 ' + shownLogs.length + '건' }})</small></b-button>
            </div>
            <div class="table-responsive inreg__table">
              <table class="table table-sm table-bordered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width:30px"><input type="checkbox" :checked="allLogsPicked" title="全选" @change="pickedLogs = allLogsPicked ? [] : shownLogs.map(l => l._id)"></th>
                    <th>时间<br><small>(시각)</small></th>
                    <th>入仓位置号<br><small>(위치)</small></th>
                    <th>托盘号<br><small>(팔레트)</small></th>
                    <th>快递单号<br><small>(운송장)</small></th>
                    <th>照片<br><small>(사진)</small></th>
                    <th>货主<br><small>(업체)</small></th>
                    <th>组长<br><small>(조장)</small></th>
                    <th>订单号 · 商品<br><small>(주문번호·상품)</small></th>
                    <th>登记人<br><small>(등록자)</small></th>
                    <th>出库<br><small>(출고 표시)</small></th>
                    <th>补打<br><small>(재인쇄)</small></th>
                    <th>删除<br><small>(삭제)</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="l in shownLogs" :key="l._id">
                    <td><input v-model="pickedLogs" type="checkbox" :value="l._id"></td>
                    <td class="text-nowrap">{{ fmt(l.등록일시) }}</td>
                    <td class="text-nowrap"><b>{{ l.위치번호 }}</b></td>
                    <td class="text-nowrap">
                      <template v-if="palletEdit.id === l._id">
                        <input v-model.trim="palletEdit.text" maxlength="40" class="form-control form-control-sm d-inline-block" style="width:100px" @keyup.enter="savePallet(l)">
                        <b-button size="sm" variant="primary" class="py-0" @click="savePallet(l)">保存</b-button>
                        <b-button size="sm" variant="light" class="py-0" @click="palletEdit = { id: '', text: '' }">取消</b-button>
                      </template>
                      <template v-else>
                        <b>{{ l.팔레트번호 || '' }}</b>
                        <b-button size="sm" variant="link" class="p-0 ml-1" title="修改托盘号(팔레트번호 입력·수정)" @click="startPalletEdit(l)">✎</b-button>
                      </template>
                    </td>
                    <td class="text-nowrap">{{ l.운송장번호 || '-' }}</td>
                    <td>
                      <a v-for="(ph, i) in logPhotos(l)" :key="ph.url + i" href="javascript:void(0)" title="点击放大" @click.prevent="openLb(logPhotos(l).map(x => x.url), i)">
                        <img :src="ph.url" alt="" style="width:40px;height:40px;object-fit:cover" class="border rounded mr-1">
                      </a>
                      <small v-if="!logPhotos(l).length" class="text-muted">—</small>
                    </td>
                    <td class="text-nowrap">
                      <div v-for="r in l._rows" :key="'c' + r._id" class="small inreg__logrow">{{ r.companyid }}</div>
                      <small v-if="!l._rows.length" class="text-muted">—</small>
                    </td>
                    <td class="text-nowrap">
                      <div v-for="r in l._rows" :key="'g' + r._id" class="small inreg__logrow"><span v-if="leaderOf(r.companyid)" class="badge" :style="tagStyle(leaderOf(r.companyid))">{{ leaderOf(r.companyid) }}</span><span v-else class="text-danger">等待分配组长</span></div>
                    </td>
                    <td>
                      <div v-for="r in l._rows" :key="r._id" class="small text-nowrap inreg__logrow" :class="{ 'inreg__rocket': r._로켓 }">
                        {{ r._1688 || r.화주주문번호 || '-' }}<span v-if="r._옵션 || r.상품명"> · {{ r._옵션 || r.상품명 }}</span>
                        <span v-if="r.입창등록 && r.입창등록.위치번호 !== l.위치번호" class="badge badge-warning">现在 {{ r.입창등록.위치번호 }}</span>
                      </div>
                      <small v-if="!l._rows.length" class="text-muted">—</small>
                    </td>
                    <td class="text-nowrap">{{ l.등록자 }}</td>
                    <td class="text-nowrap small">
                      <template v-if="l.출고표시"><span class="badge badge-success">已出库</span><div>{{ l.출고표시.처리자 }}</div><div class="text-muted">{{ fmt(l.출고표시.일시) }}</div></template>
                      <span v-else class="text-muted">未出库</span>
                    </td>
                    <td class="text-nowrap">
                      <b-button size="sm" variant="outline-secondary" :disabled="!l._rows.length" @click="reprint(l)">🖨️ 补打</b-button>
                      <div class="small mt-1">
                        <span v-if="l.라벨인쇄 && l.라벨인쇄.횟수" class="badge badge-success" :title="'最近打印(최근 인쇄) ' + fmt(l.라벨인쇄.최근일시)">已打印{{ l.라벨인쇄.횟수 > 1 ? ' ×' + l.라벨인쇄.횟수 : '' }}</span>
                        <span v-else class="badge badge-danger" title="没有打印记录,可能漏打(인쇄 기록 없음 — 인쇄 빠뜨렸을 수 있음)">未打印</span>
                      </div>
                    </td>
                    <td><b-button size="sm" variant="outline-danger" :disabled="deleting === l._id" @click="removeLog(l)">🗑️ 删除</b-button></td>
                  </tr>
                  <tr v-if="!logs.length">
                    <td colspan="13" class="text-center text-muted py-3">没有记录(기록이 없습니다)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <inbound-label-print ref="printer"></inbound-label-print>
    <!-- 系统未找到 → 주문 매칭. 검색은 위 ①과 같은 API, 저장은 정상 등록과 같은 본체(서버 saveInboundRegister) -->
    <b-modal v-model="match.show" size="xl" hide-footer :title="'🔗 匹配订单(주문 매칭) — ' + (match.log ? match.log.운송장번호 : '')">
      <template v-if="match.log">
        <div v-if="(match.log.사진 || []).length" class="mb-2">
          <a v-for="(ph, i) in match.log.사진" :key="ph.url + i" href="javascript:void(0)" title="点击放大" @click.prevent="openLb(match.log.사진.map(x => x.url), i)">
            <img :src="ph.url" class="inreg__mimg mr-1" alt="">
          </a>
        </div>
        <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px">
          <b-form-select v-model="match.searchType" :options="matchTypeOptions" size="sm" style="width:190px"></b-form-select>
          <input v-model.trim="match.keyword" type="text" class="form-control form-control-sm inreg__scan" autocomplete="off"
                 placeholder="快递单号 / 订单号 / 客户名 / 商品名(운송장·주문번호·화주·상품명)" :disabled="match.finding" @keyup.enter="matchFind">
          <b-button size="sm" variant="primary" :disabled="match.finding || !match.keyword" @click="matchFind">搜索<small>(검색)</small></b-button>
          <b-spinner v-if="match.finding" small variant="primary"></b-spinner>
        </div>
        <div v-if="match.searched && !match.rows.length" class="alert alert-warning py-1 small">未找到(찾지 못함) — 换个条件再搜(다른 조건으로 검색)</div>
        <div v-if="match.rows.length" class="table-responsive inreg__table mb-2">
          <table class="table table-sm table-bordered mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width:28px"></th>
                <th>货主<br><small>(업체)</small></th>
                <th>订单号<br><small>(주문번호)</small></th>
                <th>商品<br><small>(상품)</small></th>
                <th>数量<br><small>(수량)</small></th>
                <th>出库形式<br><small>(출고형식)</small></th>
                <th>状态<br><small>(상태)</small></th>
                <th>快递单号<br><small>(운송장)</small></th>
                <th>下单 / 付款 / 发货<br><small>(주문·결제·발송일)</small></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in match.rows" :key="r._id" :class="{ 'inreg__rocket': r._로켓 }">
                <td><input v-model="r._checked" type="checkbox"></td>
                <td class="text-nowrap">{{ r.companyid }}</td>
                <td class="text-nowrap">
                  <div>{{ r._1688 || '-' }}</div>
                  <small v-if="r.화주주문번호" class="text-muted">货主 {{ r.화주주문번호 }}</small>
                </td>
                <td class="inreg__name">
                  <div class="d-flex align-items-center" style="gap:6px">
                    <img v-if="r.옵션이미지 || r.등록이미지" :src="r.옵션이미지 || r.등록이미지" style="cursor:zoom-in" title="点击放大" @click.stop.prevent="openLb([r.옵션이미지 || r.등록이미지], 0)" class="inreg__pimg" alt="">
                    <div>
                      <div class="inreg__clamp" :title="r.상품명">{{ r.상품명 }}</div>
                      <small class="text-danger">{{ r._옵션 }}</small>
                    </div>
                  </div>
                </td>
                <td class="text-right">{{ r.구매요청수량 }}</td>
                <td class="text-nowrap"><span v-if="r._출고" class="badge" :style="r._출고스타일">{{ r._출고 }}</span></td>
                <td class="text-nowrap">{{ statusText(r.processStatus) }}</td>
                <td class="small">{{ waybillText(r) }}</td>
                <!-- 세 날짜를 한 칸에 세 줄로(2026-10-04 YZY) -->
                <td class="small text-nowrap">
                  <div>下单 {{ r._주문일 || '-' }}</div>
                  <div>付款 {{ r._결제일 || '-' }}</div>
                  <div>发货 {{ r._발송일 || '-' }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-wrap align-items-center" style="gap:8px">
          <label class="mb-0">入仓位置号<small>(입창 위치번호)</small></label>
          <input v-model.trim="match.location" type="text" class="form-control form-control-sm inreg__loc" list="inregLocationList" autocomplete="off" placeholder="例 A-01-01">
          <b-button size="sm" variant="success" :disabled="match.saving || !matchChecked.length || !matchLocationValid" @click="doMatch">
            <b-spinner v-if="match.saving" small></b-spinner> 🔗 匹配并打印<small>(매칭+라벨 인쇄)</small>
          </b-button>
          <span class="small text-muted">{{ matchChecked.length }}件 · 照片转到选中的订单(사진은 고른 주문으로 옮겨집니다)</span>
          <span v-if="match.location && !matchLocationValid" class="small text-danger">位置号格式错误(형식 오류)</span>
        </div>
      </template>
    </b-modal>
    <!-- 핸드폰으로 열기 — 직원 계정으로 로그인해서 쓴다(QR 토큰 아님, 手机扫码 /m/putaway 와 같은 방식) -->
    <b-modal v-model="phone.show" hide-footer size="sm" title="📱 手机入仓(핸드폰 입창등록)">
      <div class="text-center">
        <img v-if="phone.qr" :src="phone.qr" alt="" style="width:220px;height:220px">
        <div class="small mt-2" style="word-break:break-all">{{ phone.url }}</div>
        <div class="small text-muted mt-1">用手机扫码打开，用员工账号登录(핸드폰으로 열고 직원 계정으로 로그인)</div>
        <div class="small text-muted">扫快递单号 → 拍照 → 扫位置号 → 入仓(운송장 → 촬영 → 위치 → 등록)</div>
      </div>
    </b-modal>
    <!-- 이미지 확대 — 페이지는 그대로 두고 위에 겹쳐 보여 준다(2026-10-19 崔凡 #98). 아무 데나 누르거나 Esc 로 닫는다 -->
    <div v-if="lbUrl" class="img-lightbox" @click="lbUrl = ''">
      <button v-if="lbList.length > 1" type="button" class="img-lightbox__arrow img-lightbox__arrow--l" :disabled="lbIdx <= 0" @click.stop="stepLb(-1)">‹</button>
      <img :src="lbUrl" alt="" @click.stop>
      <button v-if="lbList.length > 1" type="button" class="img-lightbox__arrow img-lightbox__arrow--r" :disabled="lbIdx >= lbList.length - 1" @click.stop="stepLb(1)">›</button>
      <div v-if="lbList.length > 1" class="img-lightbox__count">{{ lbIdx + 1 }} / {{ lbList.length }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import qrcode from 'qrcode-generator';
import JsBarcode from 'jsbarcode';
import { coupassMenuTitle } from './coupassMenu';
import { processStatusText, customsTypeText, outboundTypeOfReq, outboundTypeText, outboundTypeStyle } from '@/utils/coupassStatusText';
import InboundLabel from './InboundLabel.vue';
import InboundLabelPrint, { LABEL_QTY_MAX } from './InboundLabelPrint.vue';
import ImportPhotoPanel from './ImportPhotoPanel.vue';
import { checkLocation } from './inboundScanGuard';

// 서버 LOCATION_CODE_RE 와 같다(库位号 형식)
const LOCATION_RE = /^[A-Za-z0-9][A-Za-z0-9_.-]{0,29}$/;

// 시각 → YYYY-MM-DD. 숫자·숫자문자열(ms)·ISO·1688 웹훅의 「YYYY-MM-DD HH:mm:ss」(중국시간) — 订单列表 과 같은 해석
function dayText(v) {
  if (v == null || v === '') return '';
  const s = String(v);
  let ms;
  if (typeof v === 'number' || /^\d+$/.test(s)) ms = Number(v);
  else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(s)) ms = new Date(s.replace(' ', 'T') + '+08:00').getTime();
  else ms = new Date(s).getTime();
  if (!Number.isFinite(ms)) return s.slice(0, 10);
  const d = new Date(ms);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
// QR 카드 접힘 — 이 브라우저에만 기억(저장 못 해도 펼친 채로 동작)
const QR_OPEN_KEY = 'inboundRegister.qrOpen';
function readQrOpen() {
  try {
    return localStorage.getItem(QR_OPEN_KEY) !== '0';
  } catch (e) {
    console.error('入仓登记 QR 접힘 읽기 실패:', e);
    return true;
  }
}
function phoneUrl() {
  return window.location.origin + '/m/inbound-register';
}
function makeQr(url, cell) {
  const qr = qrcode(0, 'M');
  qr.addData(url);
  qr.make();
  return qr.createDataURL(cell, 4);
}

// 자동 새로고침 주기(등록 기록·系统未找到 목록) — 2026-10-04 YZY
const AUTO_REFRESH_MS = 30 * 1000;

function todayCN() {
  return new Date(Date.now() + 8 * 3600000).toISOString().slice(0, 10);
}

export default {
  name: 'LogisInboundRegisterV0',
  components: { InboundLabel, InboundLabelPrint, ImportPhotoPanel },
  data() {
    return {
      lbUrl: '',   // 확대해 보는 상품 이미지
      lbList: [],  // 같은 줄 사진들(좌우 화살표로 넘겨 본다)
      lbIdx: 0,
      pageTitle: coupassMenuTitle('logis.logisinboundregister'),
      LABEL_QTY_MAX,
      searchType: 'tracking',
      searchTypeOptions: [
        { value: 'tracking', text: '快递单号(운송장번호)' },
        { value: 'order1688', text: '1688订单号(1688주문번호)' },
        { value: 'order', text: '货主订单号(화주주문번호)' }
      ],
      keyword: '',
      lastKeyword: '',
      lastWaybill: '',
      finding: false,
      searched: false,
      rows: [],
      others: [],
      location: '',
      // 라벨 장수 — 인쇄 버튼 옆 한 칸, 선택한 행마다 이 장수(2026-10-04 YZY)
      labelQty: 1,
      pallet: '',          // 托盘号(손으로 쓰는 팔레트번호, 2026-10-18 崔凡 #81)
      ownerLeader: {},     // 货主 → 组长负责人(客户和客户负责人 화면)
      palletEdit: { id: '', text: '' },
      outFilter: '',        // 出库 표시 필터
      palletFilter: '',     // 托盘号 필터(2026-10-19 崔凡 #108)
      outBusy: false,
      leaderFilter: '',     // 登记记录 조장 필터
      pickedLogs: [],       // 체크한 기록(PDF 인쇄)
      saving: false,
      deleting: '',
      savedLocations: [],
      listDate: todayCN(),
      listDateTo: '',   // 끝 날짜(비우면 시작일 하루)
      listLoading: false,
      logs: [],
      phone: { show: false, url: '', qr: '' },
      // 系统未找到的快递 + 매칭 창
      unmatchedLogs: [],
      unmatchedLoading: false,
      matchTypeOptions: [
        { value: 'order1688', text: '1688订单号(1688주문번호)' },
        { value: 'order', text: '货主订单号(화주주문번호)' },
        { value: 'tracking', text: '快递单号(운송장번호)' },
        { value: 'customer', text: '客户名/货主(화주)' },
        { value: 'product', text: '商品名/1688商品名(상품명)' }
      ],
      autoTimer: null,
      phoneQr: '',
      qrOpen: readQrOpen(),
      match: { show: false, log: null, searchType: 'order1688', keyword: '', finding: false, searched: false, rows: [], location: '', saving: false }
    };
  },
  computed: {
    searchPlaceholder() {
      return { tracking: '扫描快递单号(운송장 스캔)', order1688: '输入1688订单号(1688주문번호 입력)', order: '输入货主订单号(화주주문번호 입력)' }[this.searchType];
    },
    checkedRows() {
      return this.rows.filter(r => r._checked);
    },
    allChecked() {
      return this.rows.length > 0 && this.rows.every(r => r._checked);
    },
    locationValid() {
      return checkLocation(this.location, this.lastWaybill).ok;   // 송장·바코드꼴 乱码도 거절(2026-11-01 崔凡)
    },
    leaderNames() {
      return [...new Set(Object.values(this.ownerLeader || {}))].sort((a, b) => a.localeCompare(b));
    },
    // 조장 필터 — 그 조장 货主가 하나라도 들어 있는 기록만
    shownLogs() {
      const f = this.leaderFilter;
      return this.logs.filter(l => (!f || l._rows.some(r => (this.leaderOf(r.companyid) || '__wait') === f)) &&
        (!this.outFilter || (this.outFilter === 'yes') === !!l.출고표시) &&
        (!this.palletFilter || String(l.팔레트번호 || '').toLowerCase().includes(this.palletFilter.toLowerCase())));
    },
    // 그날 入仓 件数 대비 出库 표시 현황(조장 필터를 따른다)
    outStat() {
      const f = this.leaderFilter;
      let total = 0;
      let out = 0;
      this.logs.forEach(l => {
        const n = f ? l._rows.filter(r => (this.leaderOf(r.companyid) || '__wait') === f).length : l._rows.length;
        total += n;
        if (l.출고표시) out += n;
      });
      return { total, out, rest: total - out };
    },
    allLogsPicked() {
      return this.shownLogs.length > 0 && this.shownLogs.every(l => this.pickedLogs.includes(l._id));
    },
    logRowCount() {
      return this.logs.reduce((s, l) => s + l._rows.length, 0);
    },
    matchChecked() {
      return this.match.rows.filter(r => r._checked);
    },
    matchLocationValid() {
      return LOCATION_RE.test(this.match.location);
    }
  },
  mounted() {
    this.loadOwnerLeader();
    this.loadLocations();
    this.loadList();
    this.loadUnmatched();
    this.phoneQr = makeQr(phoneUrl(), 4);
    this.$nextTick(() => this.$refs.scan && this.$refs.scan.focus());
    this.startAuto();
  },
  // 상단 탭(keep-alive)으로 숨겨지면 멈추고, 돌아오면 바로 한 번 불러온다 — 订单列表 과 같은 방식
  activated() {
    if (this.autoTimer) return;   // 처음 열릴 때는 mounted 가 이미 붙였다
    this.startAuto();
    this.autoRefresh();
  },
  deactivated() {
    this.stopAuto();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._lbKey);
    this.stopAuto();
  },
  created() {
    this._lbKey = e => { if (e.key === 'Escape') this.lbUrl = ''; else if (this.lbUrl && e.key === 'ArrowLeft') this.stepLb(-1); else if (this.lbUrl && e.key === 'ArrowRight') this.stepLb(1); };
    window.addEventListener('keydown', this._lbKey);
  },
  methods: {
    startAuto() {
      document.addEventListener('visibilitychange', this.autoRefresh);
      this.autoTimer = setInterval(this.autoRefresh, AUTO_REFRESH_MS);
    },
    stopAuto() {
      document.removeEventListener('visibilitychange', this.autoRefresh);
      if (this.autoTimer) clearInterval(this.autoTimer);
      this.autoTimer = null;
    },
    // 기록 두 목록만 다시 불러온다(검색 결과·입력칸은 안 건드린다). 화면이 안 보이거나, 입력·저장 중이거나, 창이 열려 있으면 건너뛴다
    autoRefresh() {
      if (document.visibilityState !== 'visible') return;
      if (this.match.show || this.phone.show) return;
      if (this.keyword || this.location || this.finding || this.saving || this.deleting) return;
      const el = document.activeElement;
      if (el && el.type === 'date') return;
      if (!this.listLoading) this.loadList();
      if (!this.unmatchedLoading) this.loadUnmatched();
    },
    statusText: processStatusText,
    openPhone() {
      const url = phoneUrl();
      this.phone = { show: true, url, qr: makeQr(url, 6) };
    },
    toggleQr() {
      this.qrOpen = !this.qrOpen;
      try {
        localStorage.setItem(QR_OPEN_KEY, this.qrOpen ? '1' : '0');
      } catch (e) {
        console.error('入仓登记 QR 접힘 저장 실패:', e);
      }
    },
    fmt(v) {
      const d = new Date(typeof v === 'string' && /^\d+$/.test(v) ? parseInt(v) : v);
      if (isNaN(d.getTime())) return '';
      const p = n => String(n).padStart(2, '0');
      return p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
    },
    decorate(r, extra) {
      const 출고 = outboundTypeOfReq(r);
      return Object.assign({
        ...r,
        _1688: (r.주문정보 && r.주문정보['1688주문번호']) || '',
        _옵션: [r.옵션1_중국어, r.옵션2_중국어].filter(Boolean).join(' '),
        _통관: customsTypeText(r.요청내역 && r.요청내역.customsType),
        _출고: outboundTypeText(출고),
        _출고스타일: outboundTypeStyle(출고),
        _주문일: dayText((r.주문정보 && r.주문정보.주문시간) || r.주문시간 || r.요청일),
        _결제일: dayText(r.최종결제시간),
        _발송일: dayText(r.물류정보 && r.물류정보.발송시간),
        // 로켓배송(红胶带快递) 건은 목록에서 빨간 글자(2026-10-04 YZY)
        _로켓: 출고 === '쉽먼트택배'
      }, extra || {});
    },
    toggleAll(v) {
      this.rows.forEach(r => { r._checked = v; });
    },
    async loadLocations() {
      try {
        const { data } = await axios.post('/api/warehouse/locations/list', {});
        if (data.요청결과 === '성공') this.savedLocations = (data.locations || []).map(l => l.code);
        else console.error('库位号 목록 실패:', data.error);
      } catch (e) {
        console.error('库位号 목록 오류:', e);
      }
    },
    async find() {
      const value = this.keyword.trim();
      if (!value) return;
      this.finding = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/find', { value, type: this.searchType });
        if (data.요청결과 !== '성공') {
          alert('搜索失败(검색 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        this.lastKeyword = value;
        this.lastWaybill = this.searchType === 'tracking' ? value : '';
        // 한 운송장에 여러 상품이면 행마다 라벨 1장(장수는 바꿀 수 있다)
        // 운송장이 여러 개인 주문은 자동으로 전부 체크하지 않는다(2026-10-18 崔凡 #78) — 이 소포에 든 상품만 직접 체크
        this.rows = (data.rows || []).map(r => this.decorate(r, { _checked: !(Array.isArray(r.물류정보 && r.물류정보.운송장번호목록) && r.물류정보.운송장번호목록.length > 1), _multi: Array.isArray(r.물류정보 && r.물류정보.운송장번호목록) && r.물류정보.운송장번호목록.length > 1 }));
        this.others = data.others || [];
        this.searched = true;
        this.keyword = '';
        // 찾았으면 위치 칸으로(스캐너로 바로 위치 라벨을 찍게), 못 찾았으면 검색칸 그대로
        this.$nextTick(() => {
          const el = this.rows.length ? this.$refs.loc : this.$refs.scan;
          if (el) el.focus();
        });
      } catch (e) {
        console.error('入仓登记 검색 오류:', e);
        alert('搜索错误(검색 오류): ' + e.message);
      } finally {
        this.finding = false;
      }
    },
    // 인쇄 창을 띄운 기록에 「已打印」 횟수를 남긴다(실패해도 인쇄·입고에는 영향 없음)
    async markPrinted(logIds) {
      const ids = (logIds || []).filter(Boolean).map(String);
      if (!ids.length) return;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/labelMark', { logIds: ids });
        if (data.요청결과 !== '성공') { console.error('라벨 인쇄 표시 실패:', data.error); return; }
        const now = new Date().toISOString();
        this.logs.forEach(l => { if (ids.includes(String(l._id))) l.라벨인쇄 = { 횟수: ((l.라벨인쇄 && l.라벨인쇄.횟수) || 0) + 1, 최근일시: now }; });
      } catch (e) {
        console.error('라벨 인쇄 표시 오류:', e);
      }
    },
    printList(rows, location, qty, waybill, logIds) {
      this.markPrinted(logIds);
      const n = qty === undefined ? this.labelQty : qty;
      this.$refs.printer.print(rows.map(r => ({ row: r, location, qty: n, waybill: waybill || '' })));
    },
    printOnly() {
      if (!this.locationValid) return alert('入仓位置号格式错误(위치번호 형식 오류)');   // 保存并打印 과 같은 검사(판 #851)
      this.printList(this.checkedRows, this.location.toUpperCase(), undefined, this.lastWaybill);
    },
    // 조장·물류상태 태그 색 — 이름마다 다른 색(같은 이름은 항상 같은 색)(2026-10-19 崔凡 #101)
    tagStyle(name) {
      const P = [['#fde2e4', '#a4161a'], ['#fff1cc', '#8a5a00'], ['#dff3e4', '#1b7f3b'], ['#dbeafe', '#1d4ed8'], ['#fae8ff', '#a21caf'], ['#ffe8d6', '#b45309'], ['#d9f5f1', '#0f766e'], ['#e8e4ff', '#5b21b6'], ['#fde8f3', '#be185d'], ['#e5e7eb', '#374151']];
      let h = 0;
      String(name || '').split('').forEach(ch => { h = (h * 31 + ch.charCodeAt(0)) >>> 0; });
      const c = P[h % P.length];
      return { backgroundColor: c[0], color: c[1], fontWeight: 600 };
    },
    // 사진 확대 — 같은 줄의 사진들을 좌우로 넘겨 본다(2026-10-19 崔凡 #98)
    openLb(list, i) {
      this.lbList = (list || []).filter(Boolean);
      this.lbIdx = Math.max(0, Math.min(i || 0, this.lbList.length - 1));
      this.lbUrl = this.lbList[this.lbIdx] || '';
    },
    stepLb(d) {
      const n = this.lbIdx + d;
      if (n < 0 || n >= this.lbList.length) return;
      this.lbIdx = n;
      this.lbUrl = this.lbList[n];
    },
    leaderOf(companyid) {
      return (this.ownerLeader && this.ownerLeader[companyid]) || '';
    },
    async loadOwnerLeader() {
      try {
        const { data } = await axios.post('/api/ownerLeader/map', {});
        if (data.요청결과 === '성공') this.ownerLeader = data.map || {};
      } catch (e) {
        console.error('组长负责人 표 읽기 실패:', e);
      }
    },
    startPalletEdit(l) {
      this.palletEdit = { id: l._id, text: l.팔레트번호 || '' };
    },
    async savePallet(l) {
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/pallet', { logId: l._id, 팔레트번호: this.palletEdit.text });
        if (data.요청결과 !== '성공') { alert('保存失败(저장 실패): ' + ((data.error && data.error.errorMessage) || '')); return; }
        this.$set(l, '팔레트번호', data.팔레트번호);
        this.palletEdit = { id: '', text: '' };
      } catch (e) {
        console.error('托盘号 저장 오류:', e);
        alert('保存错误(저장 오류): ' + e.message);
      }
    },
    async saveAndPrint() {
      const rows = this.checkedRows;
      if (!rows.length) return alert('请选择商品(상품을 선택하세요)');
      if (!this.locationValid) return alert('入仓位置号格式错误(위치번호 형식 오류)');
      const location = this.location.toUpperCase();
      this.saving = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/save', {
          ids: rows.map(r => r._id), 위치번호: location, 운송장번호: this.lastWaybill, 팔레트번호: this.pallet
        });
        if (data.요청결과 !== '성공') {
          alert('保存失败(저장 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        const saved = new Set(data.savedIds || []);
        if (data.skipped) alert('有 ' + data.skipped + ' 件已入库，未保存(이미 입고된 ' + data.skipped + '건은 저장 안 됨)');
        this.printList(rows.filter(r => saved.has(String(r._id))), location, undefined, this.lastWaybill, [data.logId]);
        // 다음 택배 — 결과를 비우고 스캔칸으로
        this.rows = [];
        this.others = [];
        this.searched = false;
        this.location = '';
        this.pallet = '';
        this.labelQty = 1;
        this.loadList();
        this.$nextTick(() => this.$refs.scan && this.$refs.scan.focus());
      } catch (e) {
        console.error('入仓登记 저장 오류:', e);
        alert('保存错误(저장 오류): ' + e.message);
      } finally {
        this.saving = false;
      }
    },
    async loadList() {
      this.listLoading = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/list', { date: this.listDate, dateTo: this.listDateTo });
        if (data.요청결과 !== '성공') {
          console.error('入仓登记 기록 실패:', data.error);
          if (data.error && data.error.errorMessage) alert(data.error.errorMessage);
          return;
        }
        const byId = new Map((data.rows || []).map(r => [String(r._id), this.decorate(r)]));
        this.logs = (data.logs || []).map(l => ({ ...l, _rows: (l.reqIds || []).map(id => byId.get(String(id))).filter(Boolean) }));
      } catch (e) {
        console.error('入仓登记 기록 오류:', e);
      } finally {
        this.listLoading = false;
      }
    },
    async loadUnmatched() {
      this.unmatchedLoading = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/unmatched/list', {});
        if (data.요청결과 !== '성공') {
          console.error('入仓登记 未找到 목록 실패:', data.error);
          return;
        }
        this.unmatchedLogs = data.logs || [];
      } catch (e) {
        console.error('入仓登记 未找到 목록 오류:', e);
      } finally {
        this.unmatchedLoading = false;
      }
    },
    waybillText(r) {
      const 물류 = r.물류정보 || {};
      return [...new Set([물류.운송장번호].concat(물류.운송장번호목록 || []).filter(Boolean))].join(', ') || '-';
    },
    openMatch(l) {
      this.match = { show: true, log: l, searchType: 'order1688', keyword: '', finding: false, searched: false, rows: [], location: l.위치번호 || '', saving: false };
    },
    async matchFind() {
      const value = this.match.keyword.trim();
      if (!value) return;
      this.match.finding = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/find', { value, type: this.match.searchType });
        if (data.요청결과 !== '성공') {
          alert('搜索失败(검색 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        // 한 건만 나오면 바로 체크 — 여러 건이면 사람이 고른다
        const rows = data.rows || [];
        this.match.rows = rows.map(r => this.decorate(r, { _checked: rows.length === 1 }));
        this.match.searched = true;
      } catch (e) {
        console.error('入仓登记 매칭 검색 오류:', e);
        alert('搜索错误(검색 오류): ' + e.message);
      } finally {
        this.match.finding = false;
      }
    },
    async doMatch() {
      const rows = this.matchChecked;
      const log = this.match.log;
      if (!rows.length || !log) return;
      const location = this.match.location.toUpperCase();
      this.match.saving = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/unmatched/match', {
          logId: log._id, ids: rows.map(r => r._id), 위치번호: location
        });
        if (data.요청결과 !== '성공') {
          alert('匹配失败(매칭 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        const saved = new Set(data.savedIds || []);
        if (data.skipped) alert('有 ' + data.skipped + ' 件已入库，未保存(이미 입고된 ' + data.skipped + '건은 저장 안 됨)');
        this.printList(rows.filter(r => saved.has(String(r._id))), location, 1, log.운송장번호, [log._id]);
        this.match.show = false;
        this.loadUnmatched();
        this.loadList();
      } catch (e) {
        console.error('入仓登记 매칭 오류:', e);
        alert('匹配错误(매칭 오류): ' + e.message);
      } finally {
        this.match.saving = false;
      }
    },
    // 기록의 사진 — 기록에 직접 붙은 것(系统未找到) + 묶인 주문들의 입고사진(확인사진 제외), 같은 주소는 한 번만
    logPhotos(l) {
      const seen = new Set();
      const out = [];
      [].concat(l.사진 || [], ...(l._rows || []).map(r => (Array.isArray(r.입고사진) ? r.입고사진 : []).filter(p => p && p.종류 !== '확인사진'))).forEach(p => {
        if (p && typeof p.url === 'string' && !seen.has(p.url)) { seen.add(p.url); out.push(p); }
      });
      return out;
    },
    // 一键出库 — 고른 기록에 «已出库» 표시(처리자·시각). 订单 상태는 바뀌지 않는다
    async markOut(done) {
      const ids = this.pickedLogs.slice();
      if (!ids.length) return;
      const n = this.shownLogs.filter(l => ids.includes(l._id)).reduce((s, l) => s + l._rows.length, 0);
      if (!confirm((done ? '将所选 ' + ids.length + ' 条记录(' + n + '件)标记为「已出库」? (고른 ' + ids.length + '건 · ' + n + '件을 출고 표시합니다. 订单 상태는 바뀌지 않습니다)' : '取消所选 ' + ids.length + ' 条的「已出库」标记? (출고 표시를 해제합니다)'))) return;
      this.outBusy = true;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/outMark', { logIds: ids, done });
        if (data.요청결과 !== '성공') {
          alert('操作失败(실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        this.logs.forEach(l => { if (ids.includes(l._id)) this.$set(l, '출고표시', done ? { 일시: data.일시, 처리자: data.처리자 } : null); });
        this.pickedLogs = [];
      } catch (e) {
        console.error('一键出库 오류:', e);
        alert('操作错误(오류): ' + e.message);
      } finally {
        this.outBusy = false;
      }
    },
    // 고른 기록을 표로 인쇄(PDF 로 저장 가능) — 入仓位置号 하나당 한 줄: 같은 위치번호는 합쳐 快递单号·货主·组长·订单号 를 그 줄에 모은다(2026-10-20 崔凡 #113)
    printPicked() {
      const esc = v => String(v == null ? '' : v).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
      const uniq = a => [...new Set(a.filter(Boolean))];
      const byLoc = new Map();
      this.shownLogs.filter(l => this.pickedLogs.includes(l._id)).forEach(l => {
        const k = l.위치번호 || '';
        if (!byLoc.has(k)) byLoc.set(k, { pallet: [], waybill: [], owner: [], leader: [], order: [] });
        const g = byLoc.get(k);
        g.pallet.push(l.팔레트번호); g.waybill.push(l.운송장번호);
        l._rows.forEach(r => {
          g.owner.push(r.companyid);
          g.leader.push(r.companyid ? this.leaderOf(r.companyid) : '');
          g.order.push(r._1688 || r.화주주문번호 || '');
        });
      });
      // 값마다 CODE128 바코드(SVG) — 만들지 못하면 글자로
      const barcodes = vals => uniq(vals).map(v => {
        try {
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          JsBarcode(svg, String(v), { format: 'CODE128', height: 38, width: 1.6, margin: 2, displayValue: true, fontSize: 11 });
          return '<div class="bc">' + svg.outerHTML + '</div>';
        } catch (e) {
          console.error('인쇄표 바코드 생성 실패:', v, e);
          return '<div>' + esc(v) + '</div>';
        }
      }).join('');
      const body = [...byLoc.entries()].map(([loc, g]) => '<tr><td>' + esc(loc) + '</td><td>' + esc(uniq(g.pallet).join(', ')) + '</td><td>' + esc(uniq(g.waybill).join(', ')) + '</td><td>' +
        esc(uniq(g.owner).join(', ')) + '</td><td>' + esc(uniq(g.leader).join(', ') || '-') + '</td><td>' + esc(uniq(g.order).join(', ')) + '</td><td>' + barcodes(g.order) + '</td><td>' + barcodes(g.waybill) + '</td></tr>');
      const w = window.open('', '_blank');
      if (!w) { alert('请允许弹出窗口(팝업을 허용해 주세요)'); return; }
      w.document.write('<!doctype html><html><head><meta charset="utf-8"><title>入仓登记</title><style>body{font-family:"Microsoft YaHei",sans-serif;font-size:12px}table{border-collapse:collapse;width:100%}th,td{border:1px solid #333;padding:4px 6px;text-align:left}th{background:#eee}.bc{margin:2px 0;text-align:center}.bc svg{max-width:100%}td{vertical-align:middle}</style></head><body>' +
        '<h3>入仓登记 ' + esc(this.listDate || '') + '</h3><table><thead><tr><th>入仓位置号</th><th>托盘号</th><th>快递单号</th><th>货主</th><th>组长</th><th>订单号</th><th>订单号条码</th><th>快递单号条码</th></tr></thead><tbody>' + body.join('') + '</tbody></table></body></html>');
      w.document.close();
      w.focus();
      setTimeout(() => w.print(), 300);
    },
    // 고른 기록(없으면 지금 보이는 전체)을 엑셀로 — 표의 칸 그대로, 상품 줄마다 1행(2026-10-20 崔凡 #109)
    downloadExcel() {
      const logs = this.pickedLogs.length ? this.shownLogs.filter(l => this.pickedLogs.includes(l._id)) : this.shownLogs;
      if (!logs.length) return;
      // 사진 — 엑셀에는 클릭하면 원본이 열리는 링크 칸(照片1..N)으로 넣는다. 기록당 첫 행에만(2026-10-20 崔凡 #115)
      const maxPh = Math.max(0, ...logs.map(l => this.logPhotos(l).length));
      const aoa = [['时间', '入仓位置号', '托盘号', '快递单号', '货主', '组长', '订单号', '商品', '登记人', '出库'].concat(Array.from({ length: maxPh }, (_, i) => '照片' + (i + 1)))];
      const photoLinks = [];
      logs.forEach(l => {
        const rows = l._rows.length ? l._rows : [{}];
        const urls = this.logPhotos(l).map(x => x.url);
        rows.forEach((r, ri) => {
          if (ri === 0 && urls.length) photoLinks.push({ row: aoa.length, urls });
          aoa.push([
          this.fmt(l.등록일시), l.위치번호 || '', l.팔레트번호 || '', l.운송장번호 || '', r.companyid || '',
          r.companyid ? (this.leaderOf(r.companyid) || '') : '', r._1688 || r.화주주문번호 || '', ((r.상품명 || '') + ' ' + (r._옵션 || '')).trim(),
          l.등록자 || '', l.출고표시 ? '已出库 ' + (l.출고표시.처리자 || '') + ' ' + this.fmt(l.출고표시.일시) : '未出库'
          ].concat(ri === 0 ? urls.map((u, i) => '照片' + (i + 1)) : []));
        });
      });
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      photoLinks.forEach(pl => pl.urls.forEach((u, i) => { const cell = ws[XLSX.utils.encode_cell({ r: pl.row, c: 10 + i })]; if (cell) cell.l = { Target: u, Tooltip: u }; }));
      ws['!cols'] = [18, 14, 12, 20, 14, 10, 24, 40, 10, 24].concat(Array.from({ length: maxPh }, () => 10)).map(wch => ({ wch }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '入仓登记');
      XLSX.writeFile(wb, '入仓登记_' + (this.listDate || new Date().toISOString().slice(0, 10)) + '.xlsx');
    },
    // 고른 기록 일괄 补打 — 기록마다 그때 위치번호·운송장으로, 행마다 1장씩 한 번에(2026-10-19 崔凡 #107)
    reprintPicked() {
      const list = [];
      this.shownLogs.filter(l => this.pickedLogs.includes(l._id)).forEach(l => {
        l._rows.forEach(r => list.push({ row: r, location: l.위치번호, qty: 1, waybill: l.운송장번호 || '' }));
      });
      if (!list.length) { alert('没有要打印的标签(인쇄할 라벨이 없습니다)'); return; }
      this.markPrinted(this.pickedLogs.filter(id => this.shownLogs.some(l => l._id === id && l._rows.length)));
      this.$refs.printer.print(list);
    },
    // 재인쇄 — 그때 등록한 위치번호로, 행마다 1장
    reprint(l) {
      this.printList(l._rows, l.위치번호, 1, l.운송장번호, [l._id]);
    },
    // 기록 삭제 — 그 기록으로 붙인 입창 위치도 같이 떨어진다(이후 다시 등록한 건은 그대로)
    async removeLog(l) {
      if (!confirm('删除这条登记记录? 入仓位置号也会一起删除(이 등록 기록을 삭제할까요? 입창 위치도 같이 지워집니다)')) return;
      this.deleting = l._id;
      try {
        const { data } = await axios.post('/api/warehouse/inboundRegister/delete', { logId: l._id });
        if (data.요청결과 !== '성공') {
          alert('删除失败(삭제 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        if (l.unmatched) this.loadUnmatched();
        else this.loadList();
      } catch (e) {
        console.error('入仓登记 기록 삭제 오류:', e);
        alert('删除错误(삭제 오류): ' + e.message);
      } finally {
        this.deleting = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inreg {
  &__qr {
    float: right;
    margin: 0 0 8px 12px;
    padding: 6px 8px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    text-align: center;
  }

  &__qrimg {
    width: 120px;
    height: 120px;
    cursor: zoom-in;
  }

  &__num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #0d6efd;
    color: #fff;
    font-size: 0.75rem;
    font-weight: bold;
  }

  &__scan {
    width: 320px;
    max-width: 100%;
    font-size: 1rem;
  }

  &__loc {
    width: 200px;
    font-size: 1rem;
    font-weight: bold;
  }

  &__table {
    font-size: 0.8rem;
    max-height: 50vh;
    overflow: auto;

    td,
    th {
      padding: 3px 5px !important;
      line-height: 1.3;
      vertical-align: middle;
    }

    // 좁은 화면에서 머리 글이 한 글자씩 꺾이지 않게 — 표는 가로로 민다(판 #871)
    th {
      white-space: nowrap;
    }
  }

  &__name {
    min-width: 200px;
    max-width: 320px;
  }

  &__clamp {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
  }

  &__pimg {
    width: 36px;
    height: 36px;
    object-fit: cover;
    flex: none;
  }

  &__mimg {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
  }

  &__logrow {
    max-width: 520px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__rocket,
  &__rocket td {
    color: #d63333;
    font-weight: bold;
  }

  &__preview {
    display: inline-block;
    border: 1px dashed #999;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  }
}
.img-lightbox { position: fixed; inset: 0; z-index: 2000; background: rgba(0,0,0,.72); display: flex; align-items: center; justify-content: center; cursor: zoom-out; }
.img-lightbox__arrow { position: absolute; top: 50%; transform: translateY(-50%); border: 0; background: rgba(255,255,255,.85); color: #1d4ed8; font-size: 48px; line-height: 1; width: 56px; height: 90px; border-radius: 8px; cursor: pointer; }
.img-lightbox__arrow:disabled { opacity: .3; cursor: default; }
.img-lightbox__arrow--l { left: 16px; }
.img-lightbox__arrow--r { right: 16px; }
.img-lightbox__count { position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%); color: #fff; font-size: 14px; }
.img-lightbox img { max-width: 90vw; max-height: 90vh; background: #fff; border-radius: 4px; }
</style>
